module.exports = __webpack_public_path__ + "img/pdfIcon.1fd0100.svg";